module.exports = __webpack_public_path__ + "static/media/alsoReadDefault.59084b7d.svg";